import React, { useState } from "react";
import { Menu, X } from "lucide-react";

const LINKS = [
  { id: "about", label: "About" },
  { id: "products", label: "Products" },
  { id: "trade", label: "Buy / Sell / Trade" },
  { id: "faq", label: "FAQ" },
  { id: "contact", label: "Contact" },
];

function scrollToId(id) {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
}

export default function Navbar() {
  const [open, setOpen] = useState(false);

  return (
    <header
      data-testid="site-navbar"
      className="sticky top-0 z-50 bg-white border-b-4 border-black"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 flex items-center justify-between h-20">
        <button
          data-testid="nav-logo"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          className="flex items-baseline gap-2"
          aria-label="Rocket Card Shop home"
        >
          <span className="font-heading text-3xl sm:text-4xl uppercase text-[#FF1F1F] leading-none">
            Rocket
          </span>
          <span className="font-heading text-3xl sm:text-4xl uppercase text-black leading-none">
            Card Shop
          </span>
        </button>

        <nav className="hidden md:flex items-center gap-8">
          {LINKS.map((l) => (
            <button
              key={l.id}
              data-testid={`nav-link-${l.id}`}
              onClick={() => scrollToId(l.id)}
              className="font-mono text-sm uppercase font-bold tracking-widest text-black hover:text-[#FF1F1F] transition-colors"
            >
              {l.label}
            </button>
          ))}
          <button
            data-testid="nav-cta-book"
            onClick={() => scrollToId("contact")}
            className="nb-btn-primary !text-base !px-5 !py-2.5"
          >
            Book Appt
          </button>
        </nav>

        <button
          data-testid="mobile-nav-toggle"
          onClick={() => setOpen((v) => !v)}
          className="md:hidden inline-flex items-center justify-center w-11 h-11 border-4 border-black bg-white"
          aria-label="Toggle menu"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div data-testid="mobile-menu" className="md:hidden border-t-4 border-black bg-white">
          <div className="px-6 py-4 flex flex-col gap-3">
            {LINKS.map((l) => (
              <button
                key={l.id}
                data-testid={`mobile-nav-link-${l.id}`}
                onClick={() => {
                  setOpen(false);
                  scrollToId(l.id);
                }}
                className="text-left font-mono text-sm uppercase font-bold tracking-widest py-2 border-b-2 border-black/10"
              >
                {l.label}
              </button>
            ))}
            <button
              data-testid="mobile-cta-book"
              onClick={() => {
                setOpen(false);
                scrollToId("contact");
              }}
              className="nb-btn-primary mt-2"
            >
              Book Appointment
            </button>
          </div>
        </div>
      )}
    </header>
  );
}
